export function sendToError(errorName) {
    localStorage.setItem("errorName", errorName);
    window.location.pathname = "/error";
}